var React = require('react');

function ArrowDown24x24 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20 8.99979C20 9.26563 19.891 9.51496 19.7028 9.7032L12.7034 16.7026C12.516 16.89 12.2658 16.9998 12 16.9998C11.7342 16.9998 11.4848 16.8908 11.2966 16.7026L4.29721 9.7032C4.1098 9.51579 4 9.26563 4 8.99979C4 8.45325 4.45325 8 4.99979 8H18.9986C19.5451 8 19.9983 8.45325 19.9983 8.99979H20Z"}));
}

ArrowDown24x24.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = ArrowDown24x24;

ArrowDown24x24.default = ArrowDown24x24;
